module.exports = __webpack_public_path__ + "img/icon-marker.60832fd0.svg";